// onlineStatus.js
import {
  format,
  fromUnixTime,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
} from 'date-fns';
import { TranslationNamespace } from './translationNamespace.js';

const getOnlineStatusWording = ({ lastModifiedAtUnix, i18nFn }) => {
  if (!lastModifiedAtUnix) return null;

  const lastModified = fromUnixTime(lastModifiedAtUnix);
  const daysDiff = differenceInDays(Date.now(), lastModified);
  const hoursDiff = differenceInHours(Date.now(), lastModified);
  const minutesDiff = differenceInMinutes(Date.now(), lastModified);
  if (daysDiff >= 7) {
    return i18nFn('offline_state_date', {
      interpolation: { escapeValue: false },
      date: format(lastModified, 'yyyy/MM/dd'),
      ns: TranslationNamespace.PROFILE,
    });
  }
  if (daysDiff >= 1) {
    return i18nFn('offline_state_days_ago', {
      ...[daysDiff],
      ns: TranslationNamespace.PROFILE,
    });
  }
  if (hoursDiff >= 1) {
    return i18nFn('offline_state_hours_ago', {
      ...[hoursDiff],
      ns: TranslationNamespace.PROFILE,
    });
  }
  if (minutesDiff >= 1) {
    return i18nFn('offline_state_minutes_ago', {
      ...[minutesDiff],
      ns: TranslationNamespace.PROFILE,
    });
  }
  return i18nFn('offline_state_minutes_ago', {
    ...[1],
    ns: TranslationNamespace.PROFILE,
  });
};

export { getOnlineStatusWording };
